/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Logintitle1Inputs */

const zh_auth_logintitle1 = /** @type {(inputs: Auth_Logintitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录您的账户`)
};

const en_auth_logintitle1 = /** @type {(inputs: Auth_Logintitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login to your account`)
};

const es_auth_logintitle1 = /** @type {(inputs: Auth_Logintitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión en tu cuenta`)
};

/**
* | output |
* | --- |
* | "Login to your account" |
*
* @param {Auth_Logintitle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_logintitle1 = /** @type {((inputs?: Auth_Logintitle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Logintitle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_logintitle1(inputs)
	if (locale === "en") return en_auth_logintitle1(inputs)
	return es_auth_logintitle1(inputs)
});
export { auth_logintitle1 as "auth_loginTitle" }